import { useMutation } from '@tanstack/react-query';
import { importFiles } from 'config/requests/bankOperations';

export function useImportFiles() {
  return useMutation({
    mutationFn: (data: FormData) => importFiles(data),
  });
}
